<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<v-select
				class="mt-4"
				label="依頼対象"
				v-model="requirement"
				:constructions="requirements"
				dense
				outlined
				:style="{ width: $vuetify.breakpoint.xs ? '100%' : '300px' }"
				@change="searchConstructions($event)"
			/>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:constructions="constructions"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openInNewTab(item)">
							<!-- TODO 一時的なため変更要 -->
							<td v-for="(column, i) in item" :key="i">{{ column }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
	},
	data() {
		return {
			title: "確認・承認待ち一覧",
			constructions: [], // モデル名不明のためconstructions
			requirements: [],
			requirement: null,
			authority_flag: false,
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				// TODO
			},
			dialog: false,
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		// this.fetchConstructions(this.q, page, true)
		this.constructions = [
			[
				"KJ0001",
				"KG68YM313",
				"原価見積承認",
				"ディスタンススリーブ内面ゴムライニング施工",
				"2023/4/19",
				"2023/4/20",
			],
			["KJ0002", "KG68HA122-1", "原価見積承認", "ー", "2023/4/26", "2023/4/22"],
			["KJ0003", "KG68HA097", "原価見積承認", "-", "2023/4/26", "2023/4/26"],
			[
				"KJ0004",
				"KG68YM329",
				"原価見積承認",
				"5号　循環水管短管部ゴムライニング施工",
				"2023/5/6",
				"2023/5/6",
			],
		]
	},
	methods: {
		fetchConstructions(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/constructions/pending_constructions", {
					params,
					headers,
				})
				.then((res) => {
					this.constructions = res.data.constructions
					this.pagination = res.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.requirements = res.data.requirements
						this.authority_flag = res.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchConstructions(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchConstructions(requirement) {
			// TODO
			this.q = {}
			this.fetchConstructions(this.q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		openInNewTab() {},
	},
}

</script>
